/**
 * Returns true when running on a deployed host (not localhost or loopback).
 * Used to gate dev-only features like localStorage logging and verbose error output.
 */
export function isProductionHost(): boolean {
  return (
    !window.location.hostname.includes('localhost') &&
    !window.location.hostname.includes('127.0.0.1')
  );
}
